import { render, staticRenderFns } from "./DxPostWorkAttachmentMachinaryTable.vue?vue&type=template&id=24838c01&"
import script from "./DxPostWorkAttachmentMachinaryTable.vue?vue&type=script&lang=js&"
export * from "./DxPostWorkAttachmentMachinaryTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports